import { writable } from "svelte/store";
import { trackGtagEvent } from "../helpers/gtag.js";
import persisted from "./common/persisted.js";

function createOboardingStore() {
    const { subscribe, set, update } = writable({
        isComplete: false
    });

    return {
        subscribe,
        set,
        complete(options = {}) {
            const did_skip_intro = options.did_skip_intro === true;

            update((state) => ({ ...state, isComplete: true }));
            trackGtagEvent("onboarding_complete", { did_skip_intro });
        }
    };
}

const onboarding = persisted("onboarding:v2", true, createOboardingStore());

export default onboarding;
